import React, { useRef } from 'react';

import { RibbonButton } from 'common/components';
import { ParentChildMemberHierarchiesModal } from 'common/components/modal';

import { SwapOutlined } from '@ant-design/icons';

const ParentChildMemberHierarchies = (props) => {
  const { disabled, selectedMember } = props;
  const refModal = useRef();

  const handleClick = () => {
    refModal.current && refModal.current.openModal();
  };

  return (
    <>
      <RibbonButton
        size='small'
        className='button-item-dropdown'
        icon={<SwapOutlined />}
        label={'Parent - Child Hierarchies'}
        onClick={handleClick}
        disabled={disabled}
      />
      <ParentChildMemberHierarchiesModal
        ref={refModal}
        params={{ searchText: '' }}
        mapSearch={(searchText) => ({ searchText })}
        itemIdName='companyId'
        originMember={selectedMember}
      />
    </>
  );
};

export default ParentChildMemberHierarchies;
